/* eslint-disable react-hooks/exhaustive-deps */
import React, {useCallback, useEffect, useState} from 'react';
import {Form, Formik} from 'formik';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import axios from 'axios';
import * as yup from 'yup';
import lodash from 'lodash';
import PhoneInput from 'react-phone-input-2';
import OtpInput from 'react-otp-input';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import AppButton from '../../components/AppButton';
import Text from '../../components/fields/Text';
import Select from '../../components/fields/Select';
import Radio from '../../components/fields/Radio';
import Checkbox from '../../components/fields/Checkbox';
import api from '../../services/api';
import {addNotification, getShoppingCart, retryLoginAndGetCurrentUser, setLoginDialogOpen} from '../../redux/actions';
import {ACCESS_TOKEN, PROTOCOL_HTTP, HOST_API, STORAGE} from '../../enviroment';

Login.propTypes = {
  //
};

function Login(props) {
  const [initialValues, setInitialValues] = useState({
    companyName: '',
    email: '',
    phone: '',
    nit: '',
    dni: '',
    name: '',
    lastName: '',
    phone_country_code: '',
    autoretenedor: false,
    gran_contribuyente: false,
    personType: 'natural',
    address: {},
  });

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [requireCode, setRequireCode] = useState(false);
  const [dataLogin, setDataLogin] = useState({});

  const history = useHistory();
  const dispatch = useDispatch();
  const smScreen = useMediaQuery('(max-width:768px)');

  useEffect(() => {
    fetch();
  }, []);

  const validationRegisterForm = yup.object().shape({
    name: yup.string().max(156, 'Nombre es demasiado largo').required('Nombre es requerido.'),
    lastName: yup.string().max(156, 'Apellido es demasiado largo').required('Apellido es requerido.'),
    dni: yup.number().required('Cédula es requerido.').typeError("debe de ingresar un valor valido."),
    email: yup.string().email('Ingrese un correo electrónico valido').required('Correo electrónico es requerido.'),
    phone: yup.string().required('Celular es requerido.'),
    personType: yup.string()
    .required('Campo requerido.')
    .oneOf(['legal', 'natural'])
    .typeError("este campo es obligatorio para el registro."),
    companyName:yup.string().when('personType', {
      is: 'legal',
      then: yup
          .string()
          .required('Campo requerido.')
          .typeError("debe de ingresar un valor valido.")
          .max(156, 'ka razón social es demasiado larga.'),
  }),
    nit:yup.number().when('personType', {
      is: 'legal',
      then: yup
          .number()
          .required('Campo requerido.')
          .typeError("debe de ingresar un valor valido.")
          .min(0, 'debe de colocar un valor superior a cero.'),
  }),
    dv:yup.number().when('personType', {
      is: 'legal',
      then: yup
          .number()
          .required('requerido.')
          .typeError("debe de ingresar un valor valido.")
          .min(0, 'debe de colocar un valor superior a cero.'),
  }),
  });

  const fetch = async () => {
    const {data} = await api.states.find({query: {$sort: {name: 1}}});
    setStates(data);
  };

  const fetchCities = async (state_id = 0) => {
    const {data} = await api.cities.find({
      query: {state_id, $sort: {name: 1}},
    });
    setCities(data);
  };

  const fetchUser = useCallback((email) => {
    return axios.get(`${PROTOCOL_HTTP}://${HOST_API}/authentication/check-user`, {params: {email}});
  }, []);

  function onLogin(values) {
    if (!requireCode) {
      return fetchUser(values.email).then(({data}) => {
        if (data.exist) {
          return api.authentication
            .create({
              strategy: 'email',
              email: values.email,
            })
            .then((data) => setRequireCode(data.name === 'send-token'));
        }
      });
    }

    return api.authentication
      .create({
        strategy: 'email',
        email: values.email,
        token_login_email: `${values.token}`,
      })
      .then(async (data) => {
        if (data.accessToken) {
          setRequireCode(false);
          setDataLogin(data);
          setInitialValues(
            lodash.merge(
              {...initialValues},
              {
                email: data.user.email || initialValues.email,
                phone: data.user.phone || initialValues.phone,
                dni: data.user.dni || initialValues.dni,
                name: data.user.first_name || initialValues.name,
                lastName: data.user.last_name || initialValues.lastName,
                phone_country_code: data.user.phone_country_code || initialValues.phone_country_code,
              },
            ),
          );
          STORAGE.setItem(ACCESS_TOKEN, data.accessToken);
          api.retryLogin();

          if (['active'].includes(data.user?.status)) {
            await dispatch(getShoppingCart(true));
            await dispatch(retryLoginAndGetCurrentUser());
          }
        }

        return data;
      })
      .catch((e) => {
        dispatch(addNotification(e.message, 'error'));
      });
  }

  async function save(values) {
    if (!values.email || lodash.isEmpty(values.email)) {
      dispatch(addNotification('El campo "Correo electrónico" es requerido', 'error'));
      return;
    }

    const fieldsRequired = ['name', 'lastName', 'dni', 'phone'];
    const fieldNamesRequired = ['Nombres', 'Apellidos', 'Cedual', 'Telefono'];

    for (let i = fieldsRequired.length - 1; i >= 0; i--) {
      if (!values[fieldsRequired[i]] || lodash.isEmpty(values[fieldsRequired[i]])) {
        dispatch(addNotification(`El campo "${fieldNamesRequired[i]}" es requerido`, 'error'));
        return;
      }
    }

    if (!values.address.address || lodash.isEmpty(values.address.address)) {
      dispatch(addNotification('El campo "Direccion" es requerido', 'error'));
      return;
    }

    if (!values.address.name || lodash.isEmpty(values.address.name)) {
      dispatch(addNotification('El campo "Nombre del punto" es requerido', 'error'));
      return;
    }

    if (values.personType === 'legal') {
      const legalFieldsRequired = ['companyName', 'nit', 'dv'];
      const legalFieldNamesRequired = ['Razón social', 'NIT', 'DV'];

      for (let i = legalFieldsRequired.length - 1; i >= 0; i--) {
        if (!values[legalFieldsRequired[i]] || lodash.isEmpty(values[legalFieldsRequired[i]])) {
          dispatch(addNotification(`El campo "${legalFieldNamesRequired[i]}" es requerido`, 'error'));
          return;
        }
      }
    }

    let cityId = cities.find((item) => item.name === values.city)?.id;
    let stateId = states.find((item) => item.name === values.state)?.id;

    const userData = {
      first_name: values.name,
      last_name: values.lastName,
      dni: values.dni,
      email: values.email,
      dni_digit: values.dv,
      phone: values.phone,
      phone_country_code: values.phone_country_code,
      person_type: values.personType,
      ...(values.personType === 'legal'
        ? {
            nit: values.nit,
            company_name: values.companyName,
            autoretenedor: values.autoretenedor ? 'true' : 'false',
            gran_contribuyente: values.gran_contribuyente ? 'true' : 'false',
          }
        : {}),
    };

    const createAddress = (company_id) =>
      api.addresses
        .create({
          city_id: cityId,
          state_id: stateId,
          main: 'true',
          name: values.address.name,
          address: values.address.address,
          company_id,
        })
        .then(() => {
          dispatch(retryLoginAndGetCurrentUser());
          history.push('/checkout/delivery');
        })
        .catch((e) => {
          dispatch(addNotification(e.message, 'error'));
          throw e;
        });

    if (dataLogin?.user?.id) {
      // patch
      if (
        ['pending user data', 'pending validation'].includes(dataLogin.user?.status) ||
        lodash.isEmpty(dataLogin.user.phone?.trim()) ||
        lodash.isEmpty(dataLogin.user.phone_country_code?.trim())
      ) {
        await api.users
          .patch(dataLogin.user.id, userData)
          .then(async (user) => {
            if (['active'].includes(user.status)) await dispatch(getShoppingCart(true));
            return await createAddress(user.company_id);
          })
          .catch((error) => {
            dispatch(addNotification(error.message, 'warning'));
            throw error;
          });
      }
    } else {
      // create
      await api.authentication
        .create({
          ...userData,
          email: values.email,
          strategy: 'checkout',
        })
        .then(async ({accessToken, user}) => {
          STORAGE.setItem(ACCESS_TOKEN, accessToken);
          api.retryLogin();
          if (['active'].includes(user.status)) await dispatch(getShoppingCart(true));
          await createAddress(user.company_id);
        })
        .catch((error) => {
          dispatch(addNotification(error.message, 'error'));
          throw error;
        });
    }

    if (dataLogin.accessToken) {
      await dispatch(retryLoginAndGetCurrentUser());
    }
  }

  return (
    <React.Fragment>
      {!requireCode && (
        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} my={3}>
          <Typography variant={'body1'}>Información de contacto</Typography>
          <div>
            Crea o ingresa a tu cuenta:&nbsp;
            <Link
              component={'button'}
              variant="body2"
              onClick={() => {
                dispatch(setLoginDialogOpen(true));
              }}
            >
              Iniciar sesión
            </Link>
          </div>
        </Box>
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationRegisterForm}
        enableReinitialize
        onSubmit={save}
        render={({values, handleChange, handleSubmit, setFieldValue, errors}) => (
          <Form
            onKeyPress={(event) => {
              event.key === 'Enter' && handleSubmit();
            }}
          >
            {requireCode && (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Box mb={3} clone>
                    <Typography align="center">
                      Hemos detectado que ya existe un usuario con este correo y te hemos enviado un código para validar
                      que eres tu
                    </Typography>
                  </Box>
                  <OtpInput
                    containerStyle={{justifyContent: 'center'}}
                    onChange={(otp) => setFieldValue('token', otp)}
                    numInputs={4}
                    value={values.token}
                    inputStyle={{
                      color: '#000',
                      padding: 14,
                      boxSizing: 'content-box',
                      margin: '0 20px',
                    }}
                    separator={<span>-</span>}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box display={'flex'} justifyContent={'flex-end'}>
                    <AppButton
                      round
                      disableElevation
                      color="secondary"
                      variant="contained"
                      type={'button'}
                      onClick={() => onLogin(values)}
                    >
                      Verificar
                    </AppButton>
                  </Box>
                </Grid>
              </Grid>
            )}
            {!requireCode && (
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Text
                    name={'email'}
                    label={'Correo electrónico'}
                    value={values.email}
                    onChange={handleChange}
                    onBlur={() => {
                      if (
                        values.email &&
                        // eslint-disable-next-line no-control-regex
                        /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi.test(
                          values.email,
                        )
                      ) {
                        onLogin(values).then();
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography color="textPrimary">Dirección de envío</Typography>
                  <Divider />
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <Text name={'name'} label="Nombres" value={values.name} onChange={handleChange} error={!!errors.name} helperText={errors.name}/>
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <Text name={'lastName'} label="Apellidos" value={values.lastName} onChange={handleChange} error={!!errors.lastName} helperText={errors.lastName}/>
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <Text name={'dni'} label="Cedula" value={values.dni} onChange={handleChange} error={!!errors.dni} helperText={errors.dni}/>
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <PhoneInput
                    masks={{co: '(...) ... ....'}}
                    country={'co'}
                    enableSearch
                    specialLabel={''}
                    value={values.phone_country_code + values.phone}
                    onChange={(phone, country) => {
                      setFieldValue('phone', phone.substr(country.dialCode.length));
                      setFieldValue('phone_country_code', country.dialCode);
                    }}
                    inputStyle={{
                      width: '100%',
                      border: '1px solid #e2e2e1',
                      backgroundColor: '#fcfcfb',
                      height: 58,
                    }}
                    containerStyle={{
                      width: '100%',
                    }}
                    // {...(user.phone ? {disabled: true} : {})}
                  />
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <Select
                    label={'Departamento'}
                    options={states.map(({name}) => ({
                      value: name,
                      label: name,
                    }))}
                    onChange={(e) => {
                      setFieldValue('state', e.target.value);
                      fetchCities(states.find((it) => it.name === e.target.value).id);
                    }}
                  />
                </Grid>
                <Grid item xs={smScreen ? 12 : 6}>
                  <Select
                    label={'Ciudad'}
                    options={cities.map(({name}) => ({
                      value: name,
                      label: name,
                    }))}
                    onChange={(e) => {
                      setFieldValue('city', e.target.value);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Text
                    name={'address.address'}
                    label="Dirección"
                    value={values.address.address}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Text
                    name={'address.name'}
                    label="Nombre del punto"
                    value={values.address.name}
                    onChange={handleChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Radio
                    columns={2}
                    label={'¿Compras a nombre de una empresa?'}
                    name={'personType'}
                    options={[
                      {label: 'Si', value: 'legal'},
                      {label: 'No', value: 'natural'},
                    ]}
                    value={values.personType}
                    onChange={handleChange}
                  />
                </Grid>
                {values.personType === 'legal' && (
                  <React.Fragment>
                    <Grid item md={12}>
                      <Text
                        name={'companyName'}
                        label="Razón social"
                        value={values.companyName}
                        onChange={handleChange}
                        error={!!errors.companyName}
                        helperText={errors.companyName}
                      />
                    </Grid>
                    <Grid item md={8}>
                      <Text name={'nit'} label="NIT" value={values.nit} onChange={handleChange} error={!!errors.nit}
                  helperText={errors.nit}/>
                    </Grid>
                    <Box clone display="flex" justifyContent="center" alignItems="center">
                      <Grid item md={1}>
                        -
                      </Grid>
                    </Box>
                    <Grid item md={3}>
                      <Text name={'dv'} label="DV" value={values.dv} onChange={handleChange} error={!!errors.dv}
                  helperText={errors.dv}/>
                    </Grid>
                    <Grid item xs={12}>
                      <Checkbox
                        columns={2}
                        name={'personType'}
                        options={[
                          {label: 'Auto retenedor', value: 'autoretenedor'},
                          {label: 'Gran contribuyente', value: 'gran_contribuyente'},
                        ]}
                        value={{autoretenedor: values.autoretenedor, gran_contribuyente: values.gran_contribuyente}}
                        onChange={(values) => {
                          setFieldValue('autoretenedor', values.autoretenedor);
                          setFieldValue('gran_contribuyente', values.gran_contribuyente);
                        }}
                      />
                    </Grid>
                  </React.Fragment>
                )}
                <Grid item xs={12}>
                  <Box display={'flex'} justifyContent={'flex-end'}>
                    <AppButton round disableElevation color="secondary" variant="contained" type={'submit'}>
                      Continuar
                    </AppButton>
                  </Box>
                </Grid>
              </Grid>
            )}
          </Form>
        )}
      />
    </React.Fragment>
  );
}

export default Login;
